import React from "react";
import { FaUserPlus } from "react-icons/fa";
import RegistrationForm from "../../../components/auth-layout-components/registration-form/RegistrationForm";
import { registerUser } from "../../../services/auth-service/authService";
import { useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../../utils/toast";
import { EMAIL_VERIFY_REDEIRECT_ROUTE } from "../../../configs/routes/redirectRoutes";

interface RegistrationPageProps {
  title: string;
  navigateTo: string;
  loginPage: string;
}

function RegistrationPage({ title, navigateTo, loginPage }: RegistrationPageProps) {
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>, formDdata: any) {
    e.preventDefault();
    const payload = {
      email:            formDdata.email,
      mobile_number:    formDdata.contactNumber,
      name:             formDdata.displayName,
      password:         formDdata.password,
      password_confirm: formDdata.confirmPassword,
      redirect_url:     EMAIL_VERIFY_REDEIRECT_ROUTE,
    };
    try {
      await registerUser(title, payload);
      toastSuccess("Registration successful! Verify your email and log in.");
      navigate(navigateTo);
    } catch (error: any) {
      toastError(error.response?.data?.message);
    }
  }

  return (
    <div style={{
      minHeight:      "calc(100vh - 68px)",
      display:        "flex",
      alignItems:     "center",
      justifyContent: "center",
      background:     "linear-gradient(135deg, #f8fafc 0%, #fef2f2 100%)",
      padding:        "2rem 1rem",
    }}>
      <div style={{
        width:        "100%",
        maxWidth:     500,
        background:   "#ffffff",
        borderRadius: 20,
        boxShadow:    "0 8px 40px rgba(0,0,0,0.09)",
        border:       "1.5px solid #f0f4f8",
        padding:      "2.5rem 2rem 2rem",
      }}>

        {/* Icon + title */}
        <div className="text-center mb-4">
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 56, height: 56, background: "rgba(237,27,36,0.08)", borderRadius: "50%", marginBottom: "0.75rem" }}>
            <FaUserPlus size={22} color="#ed1b24" />
          </div>
          <h4 style={{ fontWeight: 800, color: "#1e293b", marginBottom: "0.25rem", letterSpacing: "-0.03em" }}>
            {title} Registration
          </h4>
          <p style={{ color: "#94a3b8", fontSize: "0.875rem", margin: 0 }}>
            Create your account to start selling
          </p>
        </div>

        <RegistrationForm loginPage={loginPage} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
}

export default RegistrationPage;
